import React from "react";
import { AppBar, Toolbar, Box, Button, Container } from "@mui/material";
import PhoneRounded from "@mui/icons-material/PhoneRounded";
import WhatsApp from "@mui/icons-material/WhatsApp";

import "./NavBar.css";

import TitleBar from "../../components/AppBar/TitleBar/TitleBar";
import { PhoneNumberWA, PhoneNumberCall } from "../../context/Context";

const navBar = () => {
  return (
    <Box component="nav" className="site-nav" aria-label="Navigasi utama">
      <AppBar position="fixed" elevation={0} className="site-header">
        <Container maxWidth="lg">
          <Box className="nav-surface">
            <Toolbar disableGutters className="nav-toolbar">
              <TitleBar />

              <Box className="nav-actions">
                <Button
                  className="nav-call-button"
                  color="inherit"
                  href={`tel:${PhoneNumberCall}`}
                  aria-label={`Telepon ${PhoneNumberCall}`}
                  startIcon={<PhoneRounded />}
                >
                  <span className="nav-button-label">Telepon</span>
                </Button>
                <Button
                  className="nav-whatsapp-button"
                  href={`https://wa.me/${PhoneNumberWA.replace("+", "")}`}
                  target="_blank"
                  rel="noreferrer"
                  variant="contained"
                  aria-label="Konsultasi melalui WhatsApp"
                  startIcon={<WhatsApp />}
                >
                  <span className="nav-button-label">Konsultasi</span>
                </Button>
              </Box>
            </Toolbar>
          </Box>
        </Container>
      </AppBar>
    </Box>
  );
};

export default navBar;
